module.exports = __webpack_public_path__ + "img/20200421141101TIM截图20200421140148.b1e81ecb.png";